module.exports = __webpack_public_path__ + "img/18ne.a6be6e87.svg";